import {Modal, Table} from 'antd';
import {AnchorLink, PropertyList} from 'components';
import {
  formatDateRange,
  formatIBAN,
  formatIntAmount,
  formatInvoicePaymentMethod
} from 'lib/formaters';
import React, {useState} from 'react';
import {InvoiceProps} from './types';
import {percent} from './utils';

export const PreviewInvoice: React.FC<InvoiceProps> = ({invoice, account}) => {
  const [isOpen, setOpen] = useState(false);
  return (
    <>
      <AnchorLink onClick={() => setOpen(true)}>preview</AnchorLink>
      <Modal
        bodyStyle={{padding: 0}}
        width={650}
        title="Invoice"
        footer={false}
        open={isOpen}
        onCancel={() => setOpen(false)}>
        <Table
          pagination={false}
          dataSource={invoice.lineItems}
          style={{marginTop: -1}}
          bordered
          title={() => (
            <PropertyList
              properties={[
                {
                  label: 'Period',
                  value: formatDateRange(invoice.period.from, invoice.period.to)
                },
                {
                  label: 'Payment method',
                  value: formatInvoicePaymentMethod(invoice.paymentMethod)
                },
                {
                  label: 'IBAN',
                  value: formatIBAN(invoice.business?.iban || account?.iban, true)
                }
              ]}
            />
          )}
          columns={[
            {
              title: 'Name',
              dataIndex: 'name',
              key: 'name'
            },
            {
              title: 'Quantity',
              dataIndex: 'quantity',
              key: 'quantity',
              align: 'right',
              render: (value = 0, line) => {
                if (line.unitType === /*UnitType.PERCENT*/ 'percent') {
                  return formatIntAmount(value);
                }
                return value.toLocaleString();
              }
            },
            {
              title: 'Fee',
              dataIndex: 'unitAmount',
              key: 'unitAmount',
              align: 'right',
              render: (value = 0, line) => {
                if (line.unitType === /*UnitType.MONEY*/ 'money') {
                  return formatIntAmount(value);
                }
                return percent.format(value / 100);
              }
            },
            {
              title: 'Amount',
              dataIndex: 'amount',
              key: 'amount',
              align: 'right',
              render: (value = 0) => formatIntAmount(value)
            }
          ]}
          summary={() => (
            <>
              <Table.Summary.Row style={{fontWeight: 'bold', textAlign: 'right'}}>
                <Table.Summary.Cell index={0} colSpan={2} rowSpan={3} />
                <Table.Summary.Cell index={1}>Subtotal</Table.Summary.Cell>
                <Table.Summary.Cell index={2}>
                  {formatIntAmount(invoice!.amount)}
                </Table.Summary.Cell>
              </Table.Summary.Row>
              <Table.Summary.Row style={{fontWeight: 'bold', textAlign: 'right'}}>
                <Table.Summary.Cell index={1}>VAT</Table.Summary.Cell>
                <Table.Summary.Cell index={2}>{formatIntAmount(invoice!.tax)}</Table.Summary.Cell>
              </Table.Summary.Row>
              <Table.Summary.Row style={{fontWeight: 'bold', textAlign: 'right'}}>
                <Table.Summary.Cell index={1}>Total</Table.Summary.Cell>
                <Table.Summary.Cell index={2}>
                  {formatIntAmount(invoice!.totalAmount)}
                </Table.Summary.Cell>
              </Table.Summary.Row>
            </>
          )}
        />
      </Modal>
    </>
  );
};
